
import React from "react";
import { Helmet } from "react-helmet";
import "./Initial_Legal_Guidance.css";

const videoTitles = [
  "אישה שוויתרה על כתובתה וחזרה לבעלה – האם זכאית לכתובה שוב",
  "אלימות או איומים במשפחה",
  "בינה מלאכותית ועורך דין",
  "איך בוחרים עורך דין",
  " דקה לפני תחילת שנת הלימודים",
  "  דרמה בבית המשפט למשפחה בירושלים",
  "האם אישה שסילקה את בעלה מדירת המגורים זכאית לכתובה",
  " האם אפשר לבטל הסכם ממון שקיבל תוקף של פסק דין",
  "  האם אפשר לרשום ילד חילוני לבית ספר דתי",
  "  האם הרבנות מכירה בנישואין קונסרבטיביים",
  "  האם זכות לקניין רוחני של בעל שייכת גם לאישה",
  "  האם לסבא וסבתא זכות לראות אם הנכדים",
  "האם משלמים מזונות לילדים במשמורת משותפת",
  "  הגבילו את סכומי הכתובה עד 360 אלף",
  "  הילדים הם לא סוכנים חשאיים",
  "  הכלה מסרבת לצאת מבית חמותה ומקבלת תביעת פינוי",
  "  הסכם גירושין",
  "  חובות לרשויות המס",
  "  ידועים בציבור שמתחתנים צריכים שוב הסכם ממון",
  "  ייפוי כוח מתמשך או אפוטרופסות",
  "  כמה זה מזונות לילד",
  "  כשמתגרשים מחלקים הכל שווה בשווה",
  "  כתובה",
  "  למה בית משפט ממנה עורך דין לילדים קטינים",
  "  למה יקר להתגרש בישראל",
  "  למי פונים רבני או משפחה",
  "  לשלם מזונות לילדים שמסרבים להיפגש",
  "  מהו הסכם גירושין גרוע",
  "  מהי תביעה לאיזון משאבים",
  "מהי תביעה לפירוק שיתוף",
  "  מזונות לשני ילדים",
  "  תביעות לשון הרע",
];

const videos = Array.from({ length: 32 }, (_, index) => ({
  id: index + 1,
  title: videoTitles[index],
  src: `/video/${index + 1}.mp4`,
}));

export default function Initial_Legal_Guidance() {
  const seo = {
    title: "הדרכה ראשונית | משרד עורכי דין רז יוסף",
    description:
      "סרטוני הדרכה ראשונית ומידע משפטי מטעם משרד עורכי דין רז יוסף.",
    url: "https://razfamilylaw.co.il/WorksGallery",
  };

  return (
    <main className="Initial_Legal_Guidance-page" dir="rtl">
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta
          name="robots"
          content="index, follow, max-video-preview:-1"
        />
        <link rel="canonical" href={seo.url} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:url" content={seo.url} />
        <meta
          property="og:site_name"
          content="משרד עורכי דין רז יוסף"
        />
        <meta property="og:locale" content="he_IL" />
      </Helmet>

      <section className="Initial_Legal_Guidance-hero">
        <div className="Initial_Legal_Guidance-overlay">
   

          <h1>הדרכה ראשונית</h1>

          <p>
            סרטוני הדרכה ומידע משפטי ראשוני בנושאים שונים
          </p>
        </div>
      </section>

      <section className="initial-guidance">
        <div className="initial-guidance-container">
          <header className="guidance-heading">
            <span className="guidance-overline">
              מידע משפטי והדרכות
            </span>

            <h2>מרכז סרטוני ההדרכה</h2>

            <p>
              כאן תוכלו לצפות בסרטוני הדרכה בנושאים משפטיים שונים.
              בחרו בסרטון הרצוי והפעילו אותו לצפייה.
            </p>
          </header>

          <div className="guidance-grid">
            {videos.map((video) => (
              <article className="guidance-card" key={video.id}>
                <div className="guidance-card-top">
                  <span className="guidance-number">
                    {String(video.id).padStart(2, "0")}
                  </span>

                  <span className="guidance-label">
                    סרטון הדרכה
                  </span>
                </div>

                <h3 className="guidance-card-title">
                  {video.title || "כותרת הסרטון תתווסף בהמשך"}
                </h3>

                <div className="guidance-video-wrapper">
                  <video
                    className="guidance-video"
                    controls
                    controlsList="nodownload"
                    disablePictureInPicture
                    playsInline
                    preload="metadata"
                    onContextMenu={(event) => event.preventDefault()}
                  >
                    <source src={video.src} type="video/mp4" />
                    הדפדפן שלך אינו תומך בניגון וידאו.
                  </video>
                </div>

                <div className="guidance-card-footer">
                  <span>משרד עורך דין רז יוסף</span>

                  <span className="guidance-card-index">
                    {video.id} / 32
                  </span>
                </div>
              </article>
            ))}
          </div>

          <div className="guidance-disclaimer">
            <h3>חשוב לדעת</h3>

            <p>
              הסרטונים והתכנים בעמוד זה מיועדים להעברת מידע כללי
              והיכרות ראשונית עם נושאים משפטיים בלבד. אין לראות בהם
              ייעוץ משפטי אישי או תחליף לבחינת נסיבותיו של מקרה מסוים
              על ידי עורך דין. כל מקרה נבחן בהתאם לנסיבותיו ולהוראות
              הדין הרלוונטיות.
            </p>
          </div>

          <div className="guidance-contact">
            <div>
              <h2>זקוקים לייעוץ משפטי אישי?</h2>

              <p>
                ניתן לפנות למשרד לתיאום שיחה ובחינת האפשרות לקבלת
                שירות משפטי.
              </p>
            </div>

            <a
              href="/ContactSection2"
              className="guidance-contact-button"
            >
              מעבר ליצירת קשר
            </a>
          </div>
        </div>
      </section>
    </main>
  );
}
